export const ISSUING_STATUS = {
  ELIGIBLE: "eligible",
  ONBOARDING: "onboarding",
  PROCESSING: "processing",
  APPROVED: "approved",
  REJECTED: "rejected",
  REQUIRED_CARDHOLDER_AGREEMENT: "required.cardholder_agreement",
};

export const ISSUING_CARD_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  CANCELLED: 'cancelled',
};

export const ISSUING_LEGAL_ESIGN_URL = "https://stripe.com/issuing/e-sign-disclosure/legal";
export const ISSUING_LEGAL_AUTHORIZED_USER_TERMS_URL = "https://stripe.com/legal/issuing/celtic-authorized-user-terms";